import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import List from '#/common/components/List';
import { gql } from '@apollo/client';
import { getWorkOrderList } from '#/graphql/queries';
import type { WorkOrderItem } from '#/graphql/types';
import { renderFsmStateChip } from '../WorkOrderDataGrid/fsmColumns';
import type { Filter } from '#/common/components/DataGrid';

const getWorkOrderListQuery = gql(getWorkOrderList);

interface WorkOrderFsmListProps {
  permanentFilters?: Filter[];
}

/**
 * Mobile list view for the flat FSM WOLI grid.
 * Shows: WOLI Title, WOLI Number, Status, Visit Number, Visit Title.
 * Labels match the desktop grid column captions.
 */
const WorkOrderFsmList: React.FC<WorkOrderFsmListProps> = ({ permanentFilters }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (item: WorkOrderItem) => {
      navigate(`/work-orders/${item.id}`);
    },
    [navigate],
  );

  return (
    <List<WorkOrderItem>
      getItemsQuery={getWorkOrderListQuery}
      permanentFilters={permanentFilters}
      // WOLI Title as card title, WOLI Number as subtitle — matches grid captions
      titleKey="title"
      subtitleKey={(item) => item.thirdPartyNumber || item.displayNumber || ''}
      onClick={handleClick}
      customChip={(item) => renderFsmStateChip(item.state ?? undefined)}
      mobileLayout
      bodyFields={[
        {
          key: (item) => item.parent?.thirdPartyNumber || item.parent?.displayNumber || '',
          label: 'Visit Number',
        },
        {
          key: (item) => item.parent?.title || '',
          label: 'Visit Title',
        },
      ]}
    />
  );
};

export default React.memo(WorkOrderFsmList);
